export default function contains(root, n) {
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }

  return false;
}


//////////////////
// WEBPACK FOOTER
// ./~/rc-util/es/Dom/contains.js
// module id = ./node_modules/rc-util/es/Dom/contains.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons